import { Button, FormField, Input } from "@wix/design-system";
import React, { useContext, useRef, useState } from "react";
import { EditorContext, PluginsEventsContext, RicosContext } from "./../../ricos-context";
import { ReactPlayer } from "./../../wix-react-player";
import { containsUrl, generateId, MEDIA_POPOVERS_BUTTONS_NAMES_BI } from "./../../wix-rich-content-common";
import { useBiNext } from "../../_shared/use-bi-next";
import { EMBED_TAB_SUBMIT_BUTTON, EMBED_TAB_URL_INPUT } from "../dataHooks";
import classes from "../statics/styles/audio-embed-scss";
import { AUDIO_TYPE } from "../types";
import { isSoundcloudUrl } from "./utils";
const AudioEmbed = ({
  componentData,
  fetchData,
  closeModal,
  nodeId
}) => {
  const { t } = useContext(RicosContext);
  const { getEditorCommands } = useContext(EditorContext);
  const pluginsEvents = useContext(PluginsEventsContext);
  const logBi = useBiNext();
  const [url, setUrl] = useState(componentData?.audio?.src?.url || "");
  const [submittedInvalidUrl, setSubmittedInvalidUrl] = useState(false);
  const inputRef = useRef(null);
  const onEmbedClick = async () => {
    pluginsEvents.publishPluginPopoverClick?.({
      pluginId: AUDIO_TYPE,
      buttonName: MEDIA_POPOVERS_BUTTONS_NAMES_BI.embed
    });
    logBi({ dataHook: EMBED_TAB_SUBMIT_BUTTON });
    const { audio, name, coverImage, authorName, disableDownload, ...rest } = componentData;
    if (isSoundcloudUrl(url)) {
      await fetchAndEmbedAudio(url, rest);
    } else if (ReactPlayer.canPlay(url)) {
      updateRicosDocument({ audio: { src: { url } } });
      closeModal();
    } else {
      await fetchAndEmbedAudio(url, rest);
    }
  };
  const fetchAndEmbedAudio = async (url2, data) => {
    try {
      const { html } = await fetchData?.(url2) || {};
      if (html) {
        updateRicosDocument({ ...data, audio: { src: { url: url2 } }, html });
        closeModal();
      } else {
        setSubmittedInvalidUrl(true);
        inputRef.current?.focus();
      }
    } catch {
      setSubmittedInvalidUrl(true);
      inputRef.current?.focus();
    }
  };
  const updateRicosDocument = (audio) => queueMicrotask(
    () => nodeId ? getEditorCommands().setBlock(nodeId, AUDIO_TYPE, audio) : getEditorCommands().insertBlockWithBlankLines(AUDIO_TYPE, { ...audio, id: generateId() })
  );
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    FormField,
    {
      label: t("AudioModal_Embed_Title"),
      maxLines: 2,
      status: submittedInvalidUrl ? "error" : void 0,
      statusMessage: submittedInvalidUrl ? t("SoundCloudUploadModal_Input_InvalidUrl") : void 0
    },
    /* @__PURE__ */ React.createElement(
      Input,
      {
        inputRef: (ref) => {
          inputRef.current = ref;
        },
        className: classes.input,
        type: "url",
        autocomplete: "off",
        dataHook: EMBED_TAB_URL_INPUT,
        value: url,
        onChange: (e) => {
          setSubmittedInvalidUrl(false);
          setUrl(e.target.value);
        },
        placeholder: t("EmbedURL_Placeholder"),
        onBlur: () => {
          if (url && !containsUrl(url)) {
            setSubmittedInvalidUrl(true);
          }
        },
        onKeyDown: (e) => {
          if (e.key === "Enter") {
            onEmbedClick();
          }
        }
      }
    )
  ), /* @__PURE__ */ React.createElement(Button, { dataHook: EMBED_TAB_SUBMIT_BUTTON, onClick: onEmbedClick, size: "small" }, t("AudioModal_Embed_ButtonText")));
};
export {
  AudioEmbed
};
//# sourceMappingURL=audio-embed.js.map
